var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIco5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0407 5.28C9.0407 6.87058 7.45547 7.44 5.5 7.44C3.54453 7.44 1.9593 6.87058 1.9593 5.28C1.9593 3.68942 3.54453 1.68 5.5 1.68C7.45547 1.68 9.0407 3.68942 9.0407 5.28Z",
    fill: "#FFF39A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90961 0.869623C6.90961 1.80675 6.28844 2.56643 5.52219 2.56643C4.75594 2.56643 4.13477 1.80675 4.13477 0.869623C4.13477 -0.0675005 4.75594 0.00111973 5.52219 0.00111973C6.28844 0.00111973 6.90961 -0.0675005 6.90961 0.869623Z",
    fill: "#FFF39A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 9.26259C10.75 11.197 8.39949 12 5.5 12C2.60051 12 0.25 11.197 0.25 9.26259C0.25 7.32816 2.60051 5.76 5.5 5.76C8.39949 5.76 10.75 7.32816 10.75 9.26259Z",
    fill: "#FFF39A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco5);
export default __webpack_public_path__ + "static/media/ico-5.d7e4cd36bd6c48c357a4686fec4cec60.svg";
export { ForwardRef as ReactComponent };